import { DEFAULT, match } from '@/utils/pattern-match-util'
import type { JobScopeChangeStatus } from '@/features/jobs/job-scope-changes/JobScopeChange'
import { dateFormatters } from '@/utils/date-util'
import { formatMoney } from '@/utils/money-util'

/**
 * Formats the job scope change status.
 */
export function formatJobScopeChangeStatus(
  status: JobScopeChangeStatus,
): string {
  return match(status, {
    PendingClientApproval: 'Pending your review',
    Accepted: 'Update accepted',
    Rejected: 'Update rejected',
    [DEFAULT]: 'Unspecified',
  })
}

/**
 * Formats the job scope change description based on the status.
 */
export function formatJobScopeChangeDescription(
  status: JobScopeChangeStatus,
  createdAt: Date,
): string {
  return match(status, {
    Accepted: `You accepted an updated on ${dateFormatters.dateTimeDefault.format(createdAt)}`,
    Rejected: `You rejected an updated on ${dateFormatters.dateTimeDefault.format(createdAt)}`,
    PendingClientApproval: `Additional amount due since ${dateFormatters.dateTimeDefault.format(createdAt)}`,
    [DEFAULT]: 'Unspecified',
  })
}

/**
 * Formats the job scope change item quantity.
 */
export function formatJobScopeChangeItemQuantity(quantity: number): string {
  if (quantity === 0) {
    return quantity.toString()
  }

  return quantity > 0 ? `+ ${quantity}` : `- ${Math.abs(quantity)}`
}

/**
 * Formats the job scope change item price.
 */
export function formatJobScopeChangeItemPrice(price: number): string {
  return price >= 0 ? formatMoney(price, true) : formatMoney(price, true)
}
